<template>
	<div class="download-svg">
		<svg version="1.1" id="hovermou" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="28px" height="28px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
			<polygon fill="none" stroke="#22658A" stroke-width="4" stroke-miterlimit="10" points="78.637,38.119 20.649,38.119 
	20.649,76.082 78.637,76.082 ">
			<animate
				attributeName="points"
				arrtibuteType="XML"
				to="86.486,38.119 28.137,38.119 20.52,76.082 77.137,76.082"
				begin="hovermou.mouseenter"
				dur="0.3s"
				fill="freeze"/>
				<animate
				attributeName="points"
				arrtibuteType="XML"
				to="78.637,38.119 20.649,38.119 20.649,76.082 78.637,76.082"
				begin="hovermou.mouseleave"
				dur="0.3s"
				fill="freeze"/>
			</polygon>
			<path fill="none" stroke="#22658A" stroke-width="4" stroke-miterlimit="10" d="M20.649 76.08 
				c0 0 0 -41.055 0 -44.003
				c0 -1.188 0.489 -3.764 4.125 -3.764
				c3.636 0 11.437 0 12.878 0
				c1.896 0 2.573 0.78 2.945 1.357
				c0.5 0.5  1.5 2 1.5 2
				c0 0 0.5 1 2 1.5
				c0.986 0 14.196 0,14.196 0">
				<animate
				attributeName="d"
				arrtibuteType="XML"
				to="M20.649 76.08
				c0 0 -3.409 -41.947 -3.529 -43.379
				c-0.098 -1.184 0.178 -3.764 3.813 -3.764
				c3.8 0 10 0 11.4 0
				c1.896,0,2.572,0.78,2.945,1.357
				c0.372,0.577,1.406,2.169,1.406,2.169
				c0 0 0.6 1.2 2 1.2
				c0.986,0,18.168,0,18.168,0"
				begin="hovermou.mouseenter"
				dur="0.3s"
				fill="freeze"/>
				<animate
				attributeName="d"
				arrtibuteType="XML"
				to="M20.649 76.08 
				c0 0 0 -41.055 0 -44.003
				c0 -1.188 0.489 -3.764 4.125 -3.764
				c3.636 0 11.437 0 12.878 0
				c1.896 0 2.573 0.78 2.945 1.357
				c0.5 0.5  1.5 2 1.5 2
				c0 0 0.5 1 2 1.5
				c0.986 0 14.196 0,14.196 0"
				begin="hovermou.mouseleave"
				dur="0.3s"
				fill="freeze"/>
			</path>
		</svg>
	</div>
</template>

<script type="text/ecmascript-6">
	let svgns = "http://www.w3.org/2000/svg"
	// let animate = document.createElementNS(svgns,'animate')
	// animate.setAttributeNS(null,'attributeName','points')
	// animate.setAttributeNS(null,'arrtibuteType','XML')
	// animate.setAttributeNS(null,'to','86.486,38.119 28.137,38.119 20.52,76.082 77.137,76.082')
	// animate.setAttributeNS(null,'begin','0s')
	// animate.setAttributeNS(null,'dur','3s')

export default {
	methods:{
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	// svg
	// 	position: relative	
	// 	.path
	// 		stroke-dasharray: 60
	// 		stroke-dashoffset: 0
	// 		animation: dash 1s 
	// 		position: relative

	// 	@keyframes dash
	// 		0%
	// 			stroke-dashoffset: 60
	// 		100%
	// 			stroke-dashoffset: 0
</style>




// WEBPACK FOOTER //
// src/common/only-svg/open-book.vue